import facetsToIndexJSON from "@/lib/prismicio/prismic-facets-to-index.json";
import robotstxtJSON from "@/lib/prismicio/prismic-robots-txt.json";
import { getRobotsMetaTagBase } from "@jog/shared";
import { useMemo } from "react";
export const useRobotsMetaTag = (path) => {
    return useMemo(() => typeof window !== "undefined"
        ? getRobotsMetaTagBase(facetsToIndexJSON.facetsToIndex, robotstxtJSON)(path || window.location.pathname)
        : "", [path]);
};
